<template>
  <div id="app">
    <div v-if="offline" class="offlineMessage">
      You are offline. Any changes you make will be effective when you go back
      online.
    </div>
    <!-- <div v-else class="onlineMessage">You are online</div> -->
    <localization></localization>
    <update-notification></update-notification>
    <late-attendance-notification></late-attendance-notification>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Localization from '@/localization'
import { logout } from '@/services/auth'
import UpdateNotification from '@/components/update-notification'
import LateAttendanceNotification from '@/components/late-attendance-notification'
import 'mapbox-gl/dist/mapbox-gl.css'
export default {
  name: 'app',
  components: { Localization, UpdateNotification, LateAttendanceNotification },
  data() {
    return {
      offline: undefined,
    }
  },
  computed: {
    ...mapState(['settings']),
    ...mapState('user', ['authorized']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
    currentRoute() {
      return this.$route.path
    },
  },
  mounted() {
    this.$store.dispatch('user/LOAD_CURRENT_ACCOUNT')
    this.$store.commit('CHANGE_SETTING', {
      setting: 'isMenuCollapsed',
      value: false,
    })
    this.$store.commit('SET_THEME', { theme: this.settings.theme })
  },
  watch: {
    '$store.state.settings.theme'(theme) {
      this.$store.commit('SET_THEME', { theme })
    },
    authorized(authorized) {
      // When the user is sitting on the login page and their session is
      // restored by LOAD_CURRENT_ACCOUNT, redirect them away from login.
      // We intentionally do NOT check `currentRoute === '/'` here — during
      // page reload Vue Router briefly reports '/' before resolving the real
      // route, which caused unwanted redirects away from the current page.
      if (authorized && this.currentRoute === '/auth/login') {
        this.$router.replace(this.nextRoute)
      }
    },
    $route(to, from) {
      if (to.fullPath === '/auth/login') {
        this.$store.commit('CHANGE_SETTING', {
          setting: 'isMenuCollapsed',
          value: false,
        })
      }
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
  methods: {
    async logout() {
      try {
        await logout()
      } catch (error) {
        alert(error.message)
      }
    },
  },
}
</script>

<style>
.offlineMessage {
  background-color: rgb(104, 185, 104);
}

.c-h {
  cursor: pointer;
}

/*SWAL UI*/
.swal2-confirm {
  border-radius: 6px !important;
  background: #152f4a !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 1.1px !important;
  -webkit-box-shadow: 0px 0px 10px rgb(21 47 74 / 10%) !important;
  box-shadow: 0px 0px 10px rgb(21 47 74 / 10%) !important;
  color: #ffffff !important;
}

.swal2-cancel {
  border-radius: 6px !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 1.1px !important;
  -webkit-box-shadow: 0px 0px 10px rgb(21 47 74 / 10%) !important;
  box-shadow: 0px 0px 10px rgb(21 47 74 / 10%) !important;
  color: #ffffff !important;
}
</style>
